import React from 'react'

const PostDiagnosticIcon = ({ ariaHidden }) => (
  <svg
    aria-hidden={ariaHidden}
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g fill="#CCCCCC">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M21.913 2.83705H23.4783C23.7663 2.83705 24 3.07079 24 3.35881V20.0552C24 20.3432 23.7663 20.5769 23.4783 20.5769H17.2174C16.2762 20.5769 14.087 20.8316 14.087 23.1857C14.087 23.4738 13.8532 23.7075 13.5652 23.7075H10.4348C10.1468 23.7075 9.91304 23.4738 9.91304 23.1857C9.91304 20.8316 7.72383 20.5769 6.78261 20.5769H0.521739C0.233739 20.5769 0 20.3432 0 20.0552V3.35881C0 3.07079 0.233739 2.83705 0.521739 2.83705H2.08696V1.27176C2.08696 0.983749 2.3207 0.75 2.6087 0.75H8.86957C10.367 0.75 11.4209 1.24567 12 2.20363C12.5791 1.24567 13.633 0.75 15.1304 0.75H21.3913C21.6793 0.75 21.913 0.983749 21.913 1.27176V2.83705ZM20.8696 1.79352H15.1304C13.3263 1.79352 12.5217 2.59808 12.5217 4.40233V18.2812C13.1311 17.7292 14.0045 17.4464 15.1304 17.4464H20.8696V1.79352ZM3.13043 1.79352H8.86957C10.6737 1.79352 11.4783 2.59808 11.4783 4.40233V18.2843C10.8605 17.7344 9.98296 17.4464 8.86957 17.4464H3.13043V1.79352ZM17.2174 19.5334H22.9565V3.88057H21.913V17.9681C21.913 18.2561 21.6793 18.4899 21.3913 18.4899H15.1304C13.3388 18.4899 12.5384 19.2944 12.5384 21.0987C12.5384 21.3867 12.3047 21.6205 12.0167 21.6205C11.7287 21.6205 11.495 21.3867 11.495 21.0987C11.495 19.2944 10.6852 18.4899 8.86957 18.4899H2.6087C2.3207 18.4899 2.08696 18.2561 2.08696 17.9681V3.88057H1.04348V19.5334H6.78261C9.11374 19.5334 10.6863 20.7449 10.9252 22.664H13.0748C13.3137 20.7449 14.8873 19.5334 17.2174 19.5334Z" />
      </g>
    </g>
  </svg>
)

export default PostDiagnosticIcon
